
export enum REGIONS {
    "Institutional" = "Institutional",
    "Energy_Special_risks" = "Energy & Special risks",
    "Corporate_1" = "Corporate 1",
    "Corporate_2" = "Corporate 2",
    "Corporate_3" = "Corporate 3",
    "Lagos_Region"  = "Lagos Region",
    "Abuja_North_Central_Region" = "Abuja & North Central Region",
    "North_Region" = "North Region",
    "East_Region" = "East Region",
    "South_Region" = "South Region",
    "Midwest_Region" = "Midwest Region",
    "West_Region" = "West Region",
}

export enum RELATIONSHIPS {
    'Spouse' = 'Spouse',
    'Parent' = 'Parent',
    'Sibling' = 'Sibling',
    'Child' = 'Child',
    'Grandparent' = 'Grandparent',
    'Grandchild' = 'Grandchild',
    'Aunt/Uncle' = 'Aunt/Uncle',
    'Niece/Nephew' = 'Niece/Nephew',
    'Cousin' = 'Cousin',
    'Guardian' = 'Guardian',
    'Others' = 'Others',
}